import React, { useEffect, useRef } from "react";

const InnerSection = ({ children }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(10px)";
    requestAnimationFrame(() => {
      el.style.transition = "opacity 0.35s ease-out, transform 0.35s ease-out";
      el.style.opacity = "1";
      el.style.transform = "translateY(0px)";
    });
  }, []);

  return (
    <div
      ref={ref}
      style={{
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        background: "rgba(255, 255, 255, 0.65)",
        borderRadius: 16,
        padding: "24px 28px",
        marginTop: 20,
        border: "1px solid rgba(255, 255, 255, 0.4)",
        boxShadow:
          "0 8px 24px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
      }}
    >
      {children}
    </div>
  );
};

export default InnerSection;
